import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('gugu_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401 && window.location.pathname !== '/login') {
      // Limpa os dados locais e emite evento — o AuthContext escuta e faz
      // o logout via React Router sem reload brusco (evita tela branca).
      localStorage.removeItem('gugu_token');
      localStorage.removeItem('gugu_user');
      window.dispatchEvent(new CustomEvent('gugu:session-expired'));
    }
    if (error.response?.status === 403) {
      // Import dynamically to avoid circular dependency
      import('sonner').then(({ toast }) => {
        toast.error(
          error.response?.data?.detail ||
          'Acesso negado. Apenas Administradores e Operadores podem realizar esta ação.',
          { duration: 5000 }
        );
      });
    }
    return Promise.reject(error);
  }
);

export default api;
